import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import TwoColumns from '../../components/shared/TwoColumns';

const AchieveProfitabilitySection = () => (
  <Box my="20">
    <TwoColumns
      col1={
        <StaticImage
          src="../../images/devices_72dpi_800x500.webp"
          alt="hover proposal"
        />
      }
      col2={
        <Box>
          <Heading>Achieve efficiency and profitability with ease</Heading>
          <Text mt="12" fontSize="2xl">
            Precise, multi-trade project data powers your process with
            everything from consistent estimates to precise material orders.
          </Text>
        </Box>
      }
    />
  </Box>
);

export default AchieveProfitabilitySection;
